import client from '@/http'

const load = (context, params) => {
  client.get(
    `/excludes/${params.dossierId}`
  ).then(
    (res) => {
      context.commit('SET_EXCLUDE', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const loadAll = (context) => {
  client.get(
    '/excludes'
  ).then(
    (res) => {
      context.commit('SET_EXCLUDES', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const add = (context, params) => {
  client.post(
    'excludes', {
      phrase: params.phrase
    }
  ).then(
    (res) => {
      context.commit('PUSH', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

export default {
  add,
  load,
  loadAll
}
